// Общие константы секций дашборда Совкомбанка: вид панелей (этап 1 редизайна,
// план, раздел 12) и опции локальных тумблеров тепловых карт. Секции
// (DimensionSection, NoShowSection и др.) — самостоятельные компоненты с
// локальным состоянием: переключатель панели перерисовывает только её, а не
// весь дашборд; константы живут в одном месте, чтобы вид и подписи не
// расходились между секциями.

import { SovkombankSourceFilter } from './aggregations';

// Вид панелей дашборда — этап 1 редизайна: лёгкая тень и мягкая рамка вместо
// жёсткой серой, скругление крупнее стандартного карточного, заголовок жирным.
// Строки вынесены в константы — этапы редизайна правятся в одном месте.
export const PANEL_CLASS_NAME = 'shadow-sm border-light rounded-lg';
export const PANEL_FLEX_CLASS_NAME = `flex-grow-1 ${ PANEL_CLASS_NAME }`;
export const PANEL_HEADER_CLASS_NAME = 'py-1 bg-transparent border-light font-weight-bold';

// Опции тумблера «Создал записи» — общий для тепловых карт (неявки,
// продолжительность урегулирования, загрузка офиса): в отличие от режимов,
// режет срез данных своей панели по источнику записи. «Создал сотрудник» —
// источник 'user' (createdByUser), в легенде доната «Создал» подписан
// «Пользователь»; «Прочему» отдельной опции нет — оно входит только в «Показать
// всё». «Показать всё» — первым: как у остальных тумблеров, действующее по
// умолчанию значение стоит первым.
export const SOURCE_FILTER_OPTIONS: { value: SovkombankSourceFilter, title: string }[] = [
  { value: 'all', title: 'Показать всё' },
  { value: 'client', title: 'Создал клиент' },
  { value: 'user', title: 'Создал сотрудник' },
];

// Тумблер «Показать выходные» тепловых карт (неявки, продолжительность УУ,
// загрузка офиса): подсветка нерабочих дней офисов — график смен из
// /v1/report/appointment/working/hours (общий хук useWorkingDays, стор кэширует
// по диапазону оси). «Скрыть» (по умолчанию) — карта как есть. У карт неявок и
// загрузки доступен только при шаге «день»: неделя и месяц — агрегаты, день
// внутри столбца не показать (идеи на будущее — план, раздел 6); ось
// продолжительности УУ всегда дневная, там тумблер доступен без ограничений.
export const WEEKENDS_TOGGLE_OPTIONS: { value: 'hide' | 'show', title: string }[] = [
  { value: 'hide', title: 'Скрыть выходные' },
  { value: 'show', title: 'Показать выходные' },
];

// Пустой график офисов для чернового прохода матрицы «Загрузки офиса»: ось и
// записи считаются до загрузки /working/hours, проценты — после (второй проход)
export const EMPTY_WORKING_MINUTES = new Map<string, Map<string, number>>();
